import useGame from '../../../contexts/useGame';

function EnhancedMarkdownGameName() {
  const game = useGame();

  return game.fullName;
}

export default EnhancedMarkdownGameName;
